<template>
  <div class="addOn__services">
    <div class="addOn__hub">
      <b v-if="hub">{{ hub.name }}</b><span v-if="hub">></span>
    </div>
    <div class="addOn__hub__services">
      <div class="addOn__hub__services__service" v-for="serviceName in servicesDisplay" :key="serviceName">{{ serviceName }}</div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ServicesWithHub',
  props: {
    hub: { type: Object, default: null },
    servicesNames: { type: String, default: "" },
    splittedServices: { type: Boolean, default: false }
  },
  computed: {
    servicesDisplay() {
      if(this.splittedServices) {
        return this.servicesNames.split('/')
      }

      return [this.servicesNames]
    }
  }
}

</script>

<style scoped lang="scss">
  @import '../../assets/scss/pages/_var.scss';

  .addOn__services {
    line-height: 1.5;
    display: table;
    max-width: 100%;
  }
  .addOn__hub, .addOn__hub__services {
    display: table-cell;
    vertical-align: top;
  }
  .addOn__hub__services__service {
    margin-bottom: 3px;
  }

  .addOn__hub span {
    padding: 0 5px;
    font-weight: bold;
    color: $color-pink;
  }

  .addOn__hub b {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
</style>



// WEBPACK FOOTER //
// src/components/hubs/ServicesWithHub.vue